<template>
  <div class="p-field p-col-6 p-lg-2">
    <AppFormItem label="Valor por bovino">
      <InputNumber
        :minFractionDigits="2"
        :disabled="!handleBovine"
        :modelValue="bovineValue || 0"
        @update:modelValue="$emit('update:bovineValue', $event)"
        @input="calculateByBovineValue($event)"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
      />
    </AppFormItem>
  </div>
  <div class="p-field p-col-6 p-lg-2">
    <AppFormItem label="Valor total">
      <InputNumber
        :minFractionDigits="2"
        :modelValue="totalValue"
        @update:modelValue="$emit('update:totalValue', $event)"
        @input="calculateByTotalValue($event)"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
      />
    </AppFormItem>
  </div>
</template>

<script>
export default {
  name: 'ServiceEditValues',
  props: {
    bovineCount: Number,
    bovineValue: Number,
    totalValue: Number,
    handleBovine: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    bovineCount(count) {
      if (this.handleBovine && this.bovineValue) {
        this.$emit('update:totalValue', count * this.bovineValue);
      }
    },
  },
  methods: {
    calculateByBovineValue(event) {
      this.$emit('update:totalValue', (this.bovineCount || 0) * event.value);
    },
    calculateByTotalValue(event) {
      const value = this.bovineCount ? event.value / this.bovineCount : 0;
      this.$emit('update:bovineValue', value);
    },
  },
};
</script>

<style>
</style>
